import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { t } from '../../../../types/translation/Translator';
import { FilterProps } from '../common/filter.util';
import { itemsContainText } from '../../../../util/string.util';
import { CompanyConnection } from '../../../../types/companyConnection/companyConnection';
import { Company } from '../../../../types/company';

export class CompanyConnectionFilter extends BaseFilter<CompanyConnection> {
  companies: Map<string, Company>;

  constructor(companies: Map<string, Company>) {
    super();
    this.companies = companies;
  }

  toLabel(): string {
    return t(TranslationKey.company).singular.label;
  }

  toCount(props: BaseFilterProps): number {
    return 0;
  }

  toIcon(): JSX.Element {
    return <></>;
  }

  toDropdownContent(props: BaseFilterProps): JSX.Element {
    return <></>;
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return <></>;
  }

  search(item: CompanyConnection, query: string) {
    const company = this.companies.get(item.companyId);

    return itemsContainText(query, [company?.name, item.state]);
  }

  filteredItems(items: CompanyConnection[], query: string, filterProps: FilterProps) {
    return items.filter(item => {
      return [this.search(item, query)].every(value => value === null || value);
    });
  }

  static filter(filterProps: FilterProps, item: Company | undefined) {
    return true;
  }
}
